<script lang="ts">
  import CanesFromLib from "./CanesFromLib.svelte";
  import CaneHelpers from "./CaneHelpers.svelte";
  import OriginalDescr from "../common/OriginalDescr.svelte";
  import AboutAuthor from "../../common/AboutAuthor.svelte";
</script>

<div>
  <AboutAuthor />
  
  <h4>Original description (from artblocks.io)</h4>
  <p class="italic">
    <OriginalDescr />
  </p>

  <h4>Approach</h4>
  <p>
    I used a sample reference paperweight: <img
      id="original"
      src="img/reals/murano1.jpg"
      alt="reference Murano paperweight"
    />
  </p>
  <p>
    I coded the canes from this paperweight one by one, discovering the basic
    shapes: cogwheels, spirograph like shapes, etc., which compose a cane. It
    helped me a lot to start with real, visible examples.
  </p>
  <p>
    Some of these original cane are included in Murano Fantasy paperweights, as
    is.
    <CanesFromLib width={100} />
    I then wrote a generative grammar to assemble shapes. When I started randomizing
    everything, and seeing the result, I started to see the magic happening.
  </p>
  <p>
    For the colors, I used the <a
      href="https://github.com/c0bra/color-scheme-js">color-scheme.js</a
    > library by Brian Hann. It is quite flashy by default, which is ideal for Murano
    style.
  </p>

  <h4>Generative process</h4>
  <table>
    <tbody>
      <tr>
        <th scope="row">Choose a layout type</th>
        <td>closepack, concentric, or delaunay</td>
      </tr>
      <tr>
        <th scope="row">Generate the layout</th>
        <td>arrange the canes</td>
      </tr>
      <tr>
        <th scope="row">Generate the canes</th>
        <td
          >Different shapes are generated (cogwheels, spyrograph like shapes,
          etc.), and are imbricated to make a cane. These can be very basic or
          very entangled: like with a real paperweight, you might need a
          magnifying glass.</td
        >
      </tr>
      <tr>
        <th scope="row">Put the canes on the layout</th>
        <td>depending on the layout and the chosen canes</td>
      </tr>
      <tr>
        <th scope="row">Sign the paperweight</th>
        <td
          >As a tradition, the artist might sign the paperweight. This signature
          cane can be more or less visible.</td
        >
      </tr>
    </tbody>
  </table>

  <h4>Sample cane shapes and components</h4>
  <p>
    Canes are composed of basic shapes imbricated one into another. This table
    shows these basic shapes.
  </p>
  <CaneHelpers />
</div>

<style>
  #original {
    display: block;
    width: 100%;
    max-width: 500px;
  }
</style>
